// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetMasterService = {};

AssetMasterService.getAssetMaster = function (userInput) { 
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/AssetMaster/assetMasters?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};

AssetMasterService.getSearchAssetMastersSliceList = function (userInput) { 
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/AssetMaster/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&name=" +
      userInput?.name +
      "&brandid=" +
      userInput?.brandid +
      "&brandType=" +
      userInput?.brandType +
      "&category=" +
      userInput?.category,
    method: "get",
  });
};

export default AssetMasterService;
